import { type CarrierDef } from '../common.js'
import { type DocumentType } from '../document-types.js'
import { password, username, userPassMap } from '../internal.js'

const credentialTypes = [username, password] as const
const locationCredentialTypes = ['rate-account'] as const

export type jpxsCredType =
  | (typeof credentialTypes)[number]
  | (typeof locationCredentialTypes)[number]

export const jpxsDocumentTypes = [
  'proof-of-delivery',
  'signed-bol',
] as const satisfies readonly DocumentType[]

export const jpxs: CarrierDef<jpxsCredType> = {
  name: 'JP Express',
  scac: 'jpxs',
  credentialTypes,
  locationCredentialTypes,
  legacyCredMap: [...userPassMap, ['rate-account', 'ref1']],
  engineLayers: [
    'provisioning',
    'rating',
    'pickup',
    'documents',
    'tracking',
    'profinder',
  ],
  documentTypes: jpxsDocumentTypes,
}
